import {
    ReactElement,
} from 'react';

import {Stack,} from '@mantine/core';

import {useOrganizations} from '../hooks/useOrganizations.ts';
import {useOrganizationsFilter} from '../hooks/useOrganizationsFilter.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {useOrganizationsSelection} from '../hooks/useOrganizationsSelection.ts';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {useOrganizationsPaging} from "../hooks/useOrganizationsPaging.ts";
import {useOrganizationsSearch} from "../hooks/useOrganizationsSearch.ts";
import {useOrganizationsTableColumns} from "../hooks/useOrganizationsTableColumns.tsx";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {DataTableColumn} from "mantine-datatable";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    const {filters} = useOrganizationsFilter();

    const {
        visibleItems: records,
        loading,
    } = useOrganizations(filters);

    const {
        columns,
    } = useOrganizationsTableColumns();

    const {
        page,
        limit,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = useOrganizationsPaging(records.length);

    const {
        handleFilterByKeyword,
    } = useOrganizationsSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = useOrganizationsSelection();

    let selectedRecords = [] as any[];
    if (allowedActions.includes(rbacActions.DeleteOrganization)) {
        selectedRecords = Object.keys(selection)
                                .filter(id => selection[id] === true)
                                .map(id => records.find(r => r.id === id))
                                .filter(Boolean)
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={totalCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach((item: any) => {
                        handleRowSelection(item.id, true)
                    })
                }}
                fetching={loading}
            />


        </Stack>
    );


};
